module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-remark-sequence/gatsby-browser'),
      options: {"plugins":[],"theme":"simple"},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-remark-autolink-headers/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-134623671-1"},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-netlify-cms/gatsby-browser'),
      options: {"plugins":[],"modulePath":"/opt/build/repo/packages/docs-a/src/cms/index.js"},
    },{
      plugin: require('/opt/build/repo/packages/docs-a/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
